import { render, staticRenderFns } from "./ChinaAreaData.vue?vue&type=template&id=24213052&scoped=true"
import script from "./ChinaAreaData.vue?vue&type=script&lang=js"
export * from "./ChinaAreaData.vue?vue&type=script&lang=js"
import style0 from "./ChinaAreaData.vue?vue&type=style&index=0&id=24213052&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24213052",
  null
  
)

export default component.exports